(function () {
  var selectors = {
    ageGate: '[data-totl-age-gate]',
    ageAccept: '[data-totl-age-accept]',
    ageReject: '[data-totl-age-reject]',
    retailGate: '[data-totl-retail-gate]',
    retailGateForm: '[data-totl-retail-gate-form]',
    retailGateInput: '[data-totl-retail-gate-input]',
    retailGateError: '[data-totl-retail-gate-error]',
    productForm: '[data-totl-product-form] form',
    toast: '[data-totl-cart-toast]',
    cartDrawer: '[data-totl-cart-drawer]',
    cartLines: '[data-totl-cart-lines]',
    cartCount: '[data-totl-cart-count]',
    cartSubtotal: '[data-totl-cart-subtotal]',
    cartCheckout: '[data-totl-cart-checkout]',
    cartOpen: '[data-totl-cart-open]',
    cartClose: '[data-totl-cart-close]',
    cartRemove: '[data-totl-cart-remove]',
    cartQuantity: '[data-totl-cart-quantity]',
    cartQuantityStep: '[data-totl-cart-quantity-step]',
    navBar: '.navbar.w-nav',
    navButton: '[data-totl-menu-toggle]',
    navMenu: '[data-totl-nav-menu]',
    navDropdown: '[data-totl-nav-dropdown]',
    navDropdownTrigger: '[data-totl-nav-dropdown-trigger]',
    tearSticky: '[data-totl-tear-sticky]',
    tearSection: '[data-totl-tear-section]',
    bourbonReveal: '[data-totl-bourbon-reveal]',
    bourbonStoryImage: '[data-totl-bourbon-story-image]',
    bookScene: '[data-totl-book-scene]',
    bookFlipStage: '[data-totl-book-flip-stage]',
    gameDice: '[data-totl-game-dice]',
    gameSlider: '[data-totl-game-slider]',
    homeHero: '[data-totl-home-hero]',
    heroCta: '.cta_hero_wrapper',
    bourbonGlass: '[data-totl-bourbon-reveal] .glass_wrapper',
    legendGallery: '[data-totl-legend-gallery]',
    collectorStory: '.section.collector-story',
    forceDownload: '[data-totl-force-download]',
    xLoopHolder: '[data-totl-x-loop]'
  };

  var scrollScenesBound = false;
  var scrollSceneRaf = null;
  var navScrollBound = false;
  var compareAtPriceCache = {};
  var compareAtPricePending = {};

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function lerp(start, end, amount) {
    return start + (end - start) * amount;
  }

  function smoothstep(edge0, edge1, value) {
    var amount = clamp((value - edge0) / (edge1 - edge0), 0, 1);
    return amount * amount * (3 - 2 * amount);
  }

  function setStyle(element, property, value) {
    if (element) element.style[property] = value;
  }

  function showToast(message) {
    var toast = document.querySelector(selectors.toast);
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    window.clearTimeout(showToast.timer);
    showToast.timer = window.setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 2600);
  }

  function money(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }

  function escapeHtml(value) {
    var div = document.createElement('div');
    div.textContent = value == null ? '' : String(value);
    return div.innerHTML;
  }

  function parseMoneyToCents(value) {
    if (value == null || value === '') return 0;
    if (typeof value === 'number') {
      return Number.isInteger(value) ? value : Math.round(value * 100);
    }
    var cleaned = String(value).replace(/[^0-9.-]/g, '');
    if (!cleaned) return 0;
    return cleaned.indexOf('.') >= 0 ? Math.round(Number(cleaned) * 100) : Number(cleaned) || 0;
  }

  function getCartItemHandle(item) {
    if (!item) return '';
    if (item.handle) return item.handle;
    if (item.product_handle) return item.product_handle;
    var match = item.url ? String(item.url).match(/\/products\/([^?/#]+)/) : null;
    return match ? decodeURIComponent(match[1]) : '';
  }

  function getCartItemCompareAtLinePrice(item) {
    var quantity = Number(item && item.quantity ? item.quantity : 1);
    var compareAtPrice = 0;
    if (item && item.compare_at_price) {
      compareAtPrice = parseMoneyToCents(item.compare_at_price);
    }
    if (!compareAtPrice && item && item.variant_id && compareAtPriceCache[item.variant_id] != null) {
      compareAtPrice = compareAtPriceCache[item.variant_id];
    }
    return compareAtPrice > 0 ? compareAtPrice * quantity : 0;
  }

  function getCartCompareAtSubtotal(cart) {
    if (!cart || !cart.items) return 0;
    return cart.items.reduce(function (total, item) {
      var finalLinePrice = Number(item.final_line_price || item.line_price || 0);
      var compareLinePrice = getCartItemCompareAtLinePrice(item);
      var regularLinePrice = Math.max(Number(item.original_line_price || 0), compareLinePrice, finalLinePrice);
      return total + regularLinePrice;
    }, 0);
  }

  function renderCartPriceStack(finalPrice, comparePrice, modifierClass) {
    var className = 'totl-cart-drawer__price-group' + (modifierClass ? ' ' + modifierClass : '');
    var tagName = modifierClass === 'is-subtotal' ? 'span' : 'div';
    var compareHtml = comparePrice > finalPrice ? '<' + tagName + ' class="totl-cart-drawer__compare">' + money(comparePrice) + '</' + tagName + '>' : '';
    return '<' + tagName + ' class="' + className + '">' + compareHtml + '<' + tagName + ' class="totl-cart-drawer__price">' + money(finalPrice) + '</' + tagName + '></' + tagName + '>';
  }

  function queueCompareAtPriceLookups(cart) {
    if (!cart || !cart.items || !window.fetch) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var lookups = [];

    cart.items.forEach(function (item) {
      var handle = getCartItemHandle(item);
      if (!handle || !item.variant_id || compareAtPriceCache[item.variant_id] != null || compareAtPricePending[item.variant_id]) return;

      compareAtPricePending[item.variant_id] = true;
      lookups.push(window.fetch(root + 'products/' + encodeURIComponent(handle) + '.js', {
        headers: { 'Accept': 'application/json' }
      })
        .then(function (response) {
          if (!response.ok) throw response;
          return response.json();
        })
        .then(function (product) {
          (product.variants || []).forEach(function (variant) {
            if (!variant || variant.id == null) return;
            compareAtPriceCache[variant.id] = parseMoneyToCents(variant.compare_at_price);
          });
        })
        .catch(function () {
          compareAtPriceCache[item.variant_id] = 0;
        })
        .then(function () {
          delete compareAtPricePending[item.variant_id];
        }));
    });

    if (lookups.length) {
      Promise.all(lookups).then(function () {
        renderCart(cart);
      });
    }
  }

  function setCartDrawerOpen(open) {
    // Upcart (theme.liquid) is the only cart drawer that should ever slide
    // out - opening this native one alongside it is what showed two carts
    // on Buy Now. window.totlOpenUpCart is defined synchronously (theme.liquid's
    // inline script runs before this deferred file), so it's already set by
    // the time any real click reaches here; the native drawer stays as a
    // fallback only for the (unexpected) case Upcart's script never loads.
    if (open && typeof window.totlOpenUpCart === 'function') {
      window.totlOpenUpCart();
      return;
    }
    var drawer = document.querySelector(selectors.cartDrawer);
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.documentElement.classList.toggle('totl-cart-open', open);
    document.body.classList.toggle('totl-cart-open', open);
  }

  function renderCart(cart) {
    var itemCount = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
    document.querySelectorAll(selectors.cartCount).forEach(function (count) {
      count.textContent = String(itemCount);
    });

    document.querySelectorAll(selectors.cartSubtotal).forEach(function (subtotal) {
      var finalSubtotal = Number(cart && cart.total_price ? cart.total_price : 0);
      subtotal.innerHTML = renderCartPriceStack(finalSubtotal, getCartCompareAtSubtotal(cart), 'is-subtotal');
    });

    document.querySelectorAll(selectors.cartCheckout).forEach(function (checkout) {
      checkout.disabled = itemCount === 0;
    });

    var lines = document.querySelector(selectors.cartLines);
    if (!lines) return;
    if (!cart.items || cart.items.length === 0) {
      lines.innerHTML = '<p class="totl-cart-drawer__empty">Your cart is currently empty.</p>';
      return;
    }

    queueCompareAtPriceLookups(cart);

    lines.innerHTML = cart.items.map(function (item, index) {
      var image = item.image ? '<img src="' + escapeHtml(item.image) + '" loading="lazy" alt="' + escapeHtml(item.product_title) + '" class="totl-cart-drawer__image">' : '<div class="totl-cart-drawer__image"></div>';
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<div class="totl-cart-drawer__variant">' + escapeHtml(item.variant_title) + '</div>' : '';
      var finalLinePrice = Number(item.final_line_price || item.line_price || 0);
      var compareLinePrice = getCartItemCompareAtLinePrice(item);
      var regularLinePrice = Math.max(Number(item.original_line_price || 0), compareLinePrice, finalLinePrice);
      return [
        '<article class="totl-cart-drawer__item" data-key="' + escapeHtml(item.key) + '">',
          image,
          '<div class="totl-cart-drawer__item-content">',
            '<a href="' + escapeHtml(item.url) + '" class="totl-cart-drawer__item-title">' + escapeHtml(item.product_title) + '</a>',
            variant,
            '<div class="totl-cart-drawer__meta">',
              '<label class="totl-visually-hidden" for="DrawerQuantityDynamic-' + index + '">Quantity</label>',
              '<div class="totl-cart-drawer__quantity-control" data-totl-cart-quantity-control>',
                '<button type="button" class="totl-cart-drawer__quantity-step" data-totl-cart-quantity-step data-key="' + escapeHtml(item.key) + '" data-delta="-1" aria-label="Decrease quantity">-</button>',
                '<input id="DrawerQuantityDynamic-' + index + '" class="totl-cart-drawer__quantity" type="number" min="0" value="' + item.quantity + '" data-totl-cart-quantity data-key="' + escapeHtml(item.key) + '">',
                '<button type="button" class="totl-cart-drawer__quantity-step" data-totl-cart-quantity-step data-key="' + escapeHtml(item.key) + '" data-delta="1" aria-label="Increase quantity">+</button>',
              '</div>',
              '<button type="button" class="totl-cart-drawer__remove" data-totl-cart-remove data-key="' + escapeHtml(item.key) + '">Remove</button>',
            '</div>',
          '</div>',
          renderCartPriceStack(finalLinePrice, regularLinePrice),
        '</article>'
      ].join('');
    }).join('');
  }

  function updateNavScrollState() {
    var scrollY = window.scrollY || window.pageYOffset || 0;
    var viewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;
    var isMobileViewport = viewportWidth <= 991;
    document.querySelectorAll(selectors.navBar).forEach(function (nav) {
      var hero = document.querySelector('[data-totl-home-hero], .totl-bourbon-hero, .totl-game-hero, .totl-book-page__flip');
      var threshold = 80;
      if (hero) {
        var rect = hero.getBoundingClientRect();
        threshold = Math.max(80, scrollY + rect.bottom - 140);
      }
      nav.classList.toggle('is-mobile-scrolled', isMobileViewport && scrollY > 8);
      nav.classList.toggle('is-scrolled', scrollY > threshold);
    });
  }

  function fetchCart(options) {
    return window.fetch(window.Shopify.routes.root + 'cart.js', {
      headers: { 'Accept': 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw response;
        return response.json();
      })
      .then(function (cart) {
        renderCart(cart);
        if (options && options.open) setCartDrawerOpen(true);
        return cart;
      });
  }

  function changeCartLine(key, quantity) {
    return window.fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (response) {
        if (!response.ok) throw response;
        return response.json();
      })
      .then(function (cart) {
        renderCart(cart);
        document.dispatchEvent(new CustomEvent('totl:cart:changed', { detail: { cart: cart } }));
        return cart;
      });
  }

  function initAgeGate(root) {
    var gates = (root || document).querySelectorAll(selectors.ageGate);
    gates.forEach(function (gate) {
      var storageKey = gate.getAttribute('data-storage-key') || 'totl-age-ok';
      var accepted = false;
      try {
        accepted = window.localStorage.getItem(storageKey) === 'yes';
      } catch (error) {
        accepted = false;
      }
      if (accepted || gate.getAttribute('data-enabled') !== 'true') {
        gate.hidden = true;
        document.documentElement.classList.remove('totl-age-gate-open');
        document.body.classList.remove('totl-age-gate-open');
        return;
      }
      gate.hidden = false;
      document.documentElement.classList.add('totl-age-gate-open');
      document.body.classList.add('totl-age-gate-open');
      var accept = gate.querySelector(selectors.ageAccept);
      var reject = gate.querySelector(selectors.ageReject);
      if (accept) {
        accept.addEventListener('click', function (event) {
          event.preventDefault();
          try {
            window.localStorage.setItem(storageKey, 'yes');
          } catch (error) {
            gate.dataset.storageBlocked = 'true';
          }
          gate.hidden = true;
          document.documentElement.classList.remove('totl-age-gate-open');
          document.body.classList.remove('totl-age-gate-open');
        });
      }
      if (reject) {
        reject.addEventListener('click', function (event) {
          event.preventDefault();
          var redirect = gate.getAttribute('data-redirect-url');
          if (redirect) window.location.href = redirect;
        });
      }
    });
  }

  function sha256Hex(text) {
    var data = new TextEncoder().encode(text);
    return window.crypto.subtle.digest('SHA-256', data).then(function (buffer) {
      return Array.prototype.map
        .call(new Uint8Array(buffer), function (byte) {
          return ('0' + byte.toString(16)).slice(-2);
        })
        .join('');
    });
  }

  function initRetailPasswordGate(root) {
    var gates = (root || document).querySelectorAll(selectors.retailGate);
    gates.forEach(function (gate) {
      var storageKey = gate.getAttribute('data-storage-key') || 'totl-retail-gate-ok';
      var passwordHash = gate.getAttribute('data-password-hash') || '';
      var unlocked = false;
      try {
        unlocked = window.localStorage.getItem(storageKey) === 'yes';
      } catch (error) {
        unlocked = false;
      }
      if (unlocked) {
        gate.hidden = true;
        document.documentElement.classList.remove('totl-retail-gate-open');
        document.body.classList.remove('totl-retail-gate-open');
        return;
      }
      gate.hidden = false;
      document.documentElement.classList.add('totl-retail-gate-open');
      document.body.classList.add('totl-retail-gate-open');

      var form = gate.querySelector(selectors.retailGateForm);
      var input = gate.querySelector(selectors.retailGateInput);
      var error = gate.querySelector(selectors.retailGateError);
      if (!form || !window.crypto || !window.crypto.subtle) return;

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        sha256Hex(input ? input.value : '').then(function (hash) {
          if (hash === passwordHash) {
            try {
              window.localStorage.setItem(storageKey, 'yes');
            } catch (storageError) {
              gate.dataset.storageBlocked = 'true';
            }
            gate.hidden = true;
            document.documentElement.classList.remove('totl-retail-gate-open');
            document.body.classList.remove('totl-retail-gate-open');
          } else {
            if (error) error.hidden = false;
            if (input) {
              input.value = '';
              input.focus();
            }
          }
        });
      });
    });
  }

  function initForceDownloadLinks(root) {
    var links = (root || document).querySelectorAll(selectors.forceDownload);
    links.forEach(function (link) {
      if (link.dataset.totlDownloadBound === 'true') return;
      link.dataset.totlDownloadBound = 'true';
      link.addEventListener('click', function (event) {
        var href = link.getAttribute('href');
        if (!href) return;
        event.preventDefault();
        window
          .fetch(href)
          .then(function (response) {
            if (!response.ok) throw new Error('Download request failed');
            return response.blob();
          })
          .then(function (blob) {
            var blobUrl = URL.createObjectURL(blob);
            var filename = href.split('/').pop().split('?')[0];
            var tempLink = document.createElement('a');
            tempLink.href = blobUrl;
            tempLink.download = filename || '';
            document.body.appendChild(tempLink);
            tempLink.click();
            tempLink.remove();
            window.setTimeout(function () {
              URL.revokeObjectURL(blobUrl);
            }, 1000);
          })
          .catch(function () {
            // CORS/network failure - fall back to a normal navigation so the
            // file is still reachable instead of the click doing nothing.
            window.location.href = href;
          });
      });
    });
  }

  function initProductForms(root) {
    var forms = (root || document).querySelectorAll(selectors.productForm);
    forms.forEach(function (form) {
      if (form.dataset.totlAjaxBound === 'true') return;
      form.dataset.totlAjaxBound = 'true';
      form.addEventListener('submit', function (event) {
        if (!window.fetch || form.getAttribute('data-no-ajax') === 'true') return;
        event.preventDefault();
        var button = form.querySelector('[name="add"]');
        var buttonText = button ? button.textContent : '';
        if (button) {
          button.disabled = true;
          button.textContent = 'Adding...';
        }
        window.fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          body: new FormData(form),
          headers: { 'Accept': 'application/json' }
        })
          .then(function (response) {
            if (!response.ok) throw response;
            return response.json();
          })
          .then(function () {
            return fetchCart({ open: true });
          })
          .then(function (cart) {
            showToast('Added to cart');
            document.dispatchEvent(new CustomEvent('totl:cart:changed', { detail: { cart: cart } }));
          })
          .catch(function () {
            showToast('Could not add item. Please try again.');
          })
          .finally(function () {
            if (button) {
              button.disabled = false;
              button.textContent = buttonText;
            }
          });
      });
    });
  }

  function initNav(root) {
    var scope = root || document;
    scope.querySelectorAll(selectors.navButton).forEach(function (button) {
      if (button.dataset.totlNavBound === 'true') return;
      button.dataset.totlNavBound = 'true';

      function syncMenuOpenState() {
        var menu = document.querySelector(selectors.navMenu);
        var navbar = button.closest('.navbar');
        if (!menu || !navbar) return;
        var isOpen = menu.classList.contains('w--open') || button.classList.contains('w--open') || button.getAttribute('aria-expanded') === 'true';
        button.classList.toggle('w--open', isOpen);
        button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        navbar.classList.toggle('is-menu-open', isOpen);
      }

      button.addEventListener('click', function () {
        var menu = document.querySelector(selectors.navMenu);
        if (!menu) return;
        var navbar = button.closest('.navbar');
        var expanded = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        button.classList.toggle('w--open', !expanded);
        menu.classList.toggle('w--open', !expanded);
        if (navbar) {
          navbar.classList.toggle('is-menu-open', !expanded);
        }
        window.requestAnimationFrame(syncMenuOpenState);
      });

      syncMenuOpenState();
    });
    if (!navScrollBound) {
      navScrollBound = true;
      window.addEventListener('scroll', updateNavScrollState, { passive: true });
      window.addEventListener('resize', updateNavScrollState);
    }
    updateNavScrollState();
  }

  function closeNavDropdown(wrapper) {
    wrapper.classList.remove('is-open');
    var trigger = wrapper.querySelector(selectors.navDropdownTrigger);
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
  }

  function initNavDropdowns(root) {
    var scope = root || document;
    scope.querySelectorAll(selectors.navDropdownTrigger).forEach(function (trigger) {
      if (trigger.dataset.totlNavDropdownBound === 'true') return;
      trigger.dataset.totlNavDropdownBound = 'true';

      var wrapper = trigger.closest(selectors.navDropdown);
      if (!wrapper) return;

      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var isOpen = wrapper.classList.contains('is-open');
        document.querySelectorAll(selectors.navDropdown).forEach(function (other) {
          if (other !== wrapper) closeNavDropdown(other);
        });
        wrapper.classList.toggle('is-open', !isOpen);
        trigger.setAttribute('aria-expanded', !isOpen ? 'true' : 'false');
      });
    });

    if (!document.documentElement.dataset.totlNavDropdownOutsideBound) {
      document.documentElement.dataset.totlNavDropdownOutsideBound = 'true';
      document.addEventListener('click', function (event) {
        document.querySelectorAll(selectors.navDropdown + '.is-open').forEach(function (openWrapper) {
          if (!openWrapper.contains(event.target)) closeNavDropdown(openWrapper);
        });
      });
      document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        document.querySelectorAll(selectors.navDropdown + '.is-open').forEach(closeNavDropdown);
      });
    }
  }

  function initCartDrawer(root) {
    var scope = root || document;
    scope.querySelectorAll(selectors.cartOpen).forEach(function (button) {
      if (button.dataset.totlCartOpenBound === 'true') return;
      button.dataset.totlCartOpenBound = 'true';
      button.addEventListener('click', function (event) {
        event.preventDefault();
        fetchCart({ open: true }).catch(function () {
          setCartDrawerOpen(true);
        });
      });
    });

    scope.querySelectorAll(selectors.cartClose).forEach(function (button) {
      if (button.dataset.totlCartCloseBound === 'true') return;
      button.dataset.totlCartCloseBound = 'true';
      button.addEventListener('click', function (event) {
        event.preventDefault();
        setCartDrawerOpen(false);
      });
    });

    var drawer = document.querySelector(selectors.cartDrawer);
    if (drawer && drawer.dataset.totlCartDrawerBound !== 'true') {
      drawer.dataset.totlCartDrawerBound = 'true';
      drawer.addEventListener('click', function (event) {
        var remove = event.target.closest(selectors.cartRemove);
        if (remove) {
          event.preventDefault();
          changeCartLine(remove.getAttribute('data-key'), 0).catch(function () {
            showToast('Could not update cart. Please try again.');
          });
          return;
        }
        var step = event.target.closest(selectors.cartQuantityStep);
        if (step) {
          event.preventDefault();
          var quantityControl = step.closest('[data-totl-cart-quantity-control]');
          var quantityInput = quantityControl ? quantityControl.querySelector(selectors.cartQuantity) : null;
          var delta = parseInt(step.getAttribute('data-delta'), 10) || 0;
          var currentQuantity = quantityInput ? parseInt(quantityInput.value, 10) || 0 : 0;
          var nextQuantity = Math.max(0, currentQuantity + delta);
          changeCartLine(step.getAttribute('data-key'), nextQuantity).catch(function () {
            showToast('Could not update cart. Please try again.');
          });
        }
      });
      drawer.addEventListener('change', function (event) {
        var input = event.target.closest(selectors.cartQuantity);
        if (!input) return;
        var quantity = Math.max(0, parseInt(input.value, 10) || 0);
        changeCartLine(input.getAttribute('data-key'), quantity).catch(function () {
          showToast('Could not update cart. Please try again.');
        });
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') setCartDrawerOpen(false);
      });
    }

    fetchCart().catch(function () {});
  }

  function initSmoothAnchors(root) {
    var scope = root || document;
    scope.querySelectorAll('a[href*="#"]').forEach(function (link) {
      if (link.dataset.totlSmoothAnchorBound === 'true') return;
      link.dataset.totlSmoothAnchorBound = 'true';
      link.addEventListener('click', function (event) {
        var rawHref = link.getAttribute('href');
        if (!rawHref || rawHref === '#') return;

        var url;
        try {
          url = new URL(rawHref, window.location.href);
        } catch (error) {
          return;
        }

        if (url.origin !== window.location.origin || url.pathname !== window.location.pathname || !url.hash) return;

        var targetId = decodeURIComponent(url.hash.slice(1));
        var isGameProductCta = document.body.classList.contains('template-the-game-tears-against-sanity') &&
          (targetId === 'buy' || targetId === 'buy-now');
        var isFirstProductCta = targetId === 'first-legend-product';
        var target = null;
        if (isGameProductCta) {
          // Target the product body wrapper (eyebrow + title) so the click
          // lands with "Limited Edition Game Box Set" and the product name
          // at the top of the screen, rather than scrolling past them to
          // the buy button further down the section.
          target = document.querySelector('.totl-game-product__body') ||
            document.querySelector('.totl-game-product__buy-anchor') ||
            document.getElementById('buy-now') ||
            document.querySelector('.totl-game-product__contents');
        }
        if (!target) target = document.getElementById(targetId);
        if (!target) return;

        event.preventDefault();
        // Webflow's own exported anchor-scroll handler is delegated on
        // document for the same a[href*="#"] links and runs its own
        // (longer) scroll animation toward the raw #hash element. Without
        // stopping propagation, both animations race and the Webflow one
        // finishes last, dragging the page back down past our target.
        event.stopPropagation();

        var nav = document.querySelector(selectors.navBar);
        var navHeight = nav ? nav.getBoundingClientRect().height : 0;
        // The game product title sits directly under the fixed nav, so it
        // needs full clearance (plus a little breathing room) rather than
        // the partial-overlap offset used for other anchors.
        var offset = (isGameProductCta || isFirstProductCta)
          ? navHeight + 16
          : Math.min(navHeight * 0.72, window.innerWidth <= 767 ? 74 : 96);
        var start = window.scrollY || window.pageYOffset || 0;
        var end = Math.max(0, start + target.getBoundingClientRect().top - offset);
        var distance = Math.abs(end - start);
        // Duration scales with distance so long scrolls (e.g. hero CTA down
        // to the product grid) animate at a steady, readable pace instead
        // of racing through most of the distance in the last few frames.
        var duration = isGameProductCta ? clamp(distance * 0.32, 700, 1100) : clamp(distance * 0.45, 600, 1700);
        var startTime = window.performance && window.performance.now ? window.performance.now() : Date.now();
        var htmlScrollBehavior = document.documentElement.style.scrollBehavior;
        var bodyScrollBehavior = document.body.style.scrollBehavior;

        document.documentElement.style.scrollBehavior = 'auto';
        document.body.style.scrollBehavior = 'auto';

        function easeInOutCubic(value) {
          return value < 0.5
            ? 4 * value * value * value
            : 1 - Math.pow(-2 * value + 2, 3) / 2;
        }

        var settledEnd = end;

        // Sections above the target (promo banners, social embeds, etc.)
        // can still be pulling in lazy-loaded images while this animation
        // runs. If one of those finishes loading after we've stopped and
        // grows taller, it pushes the target down and leaves the page
        // resting short of it. Re-measure for a bit after we land and nudge
        // into place, but only while the user hasn't scrolled away on
        // their own.
        function correctForLateLayoutShift() {
          if (!document.body.contains(target)) return;
          var current = window.scrollY || window.pageYOffset || 0;
          if (Math.abs(current - settledEnd) > 4) return;
          var fresh = Math.max(0, current + target.getBoundingClientRect().top - offset);
          if (Math.abs(fresh - current) > 2) {
            window.scrollTo(0, fresh);
            settledEnd = fresh;
          }
        }

        function finishScroll() {
          document.documentElement.style.scrollBehavior = htmlScrollBehavior;
          document.body.style.scrollBehavior = bodyScrollBehavior;
          if (window.history && window.history.pushState) {
            window.history.pushState(null, '', url.hash);
          }
          [200, 500, 1000, 1800].forEach(function (delay) {
            window.setTimeout(correctForLateLayoutShift, delay);
          });
        }

        function animateScroll(timestamp) {
          var progress = clamp((timestamp - startTime) / duration, 0, 1);
          window.scrollTo(0, Math.round(lerp(start, end, easeInOutCubic(progress))));
          if (progress < 1) {
            window.requestAnimationFrame(animateScroll);
          } else {
            finishScroll();
          }
        }

        animateScroll(startTime + 16);
      });
    });
  }

  function initShowAllReveal(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-totl-show-all-trigger]').forEach(function (trigger) {
      if (trigger.dataset.totlShowAllBound === 'true') return;
      trigger.dataset.totlShowAllBound = 'true';
      var section = trigger.closest('.shopify-section') || trigger.closest('.section') || trigger.parentElement;
      var target = section ? section.querySelector('[data-totl-show-all-target]') : null;
      if (!target) return;
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        var isRevealed = target.classList.contains('is-revealed');
        target.style.display = isRevealed ? 'none' : 'block';
        target.classList.toggle('is-revealed', !isRevealed);
        trigger.setAttribute('aria-expanded', String(!isRevealed));
        trigger.classList.toggle('is-revealed', !isRevealed);
      });
    });
  }

  function initGameSliders(root) {
    var scope = root || document;
    scope.querySelectorAll(selectors.gameSlider).forEach(function (slider) {
      if (slider.dataset.totlGameSliderBound === 'true') return;
      slider.dataset.totlGameSliderBound = 'true';

      var slides = Array.prototype.slice.call(slider.querySelectorAll('.totl-game-slider__slide, [data-totl-game-slide]'));
      var track = slider.querySelector('[data-totl-game-slider-track]');
      var prev = slider.querySelector('[data-totl-game-slider-prev]');
      var next = slider.querySelector('[data-totl-game-slider-next]');
      var dots = slider.querySelector('[data-totl-game-slider-dots]');
      var index = 0;

      if (!slides.length || !track) return;

      function setIndex(nextIndex) {
        index = (nextIndex + slides.length) % slides.length;
        slides.forEach(function (slide, slideIndex) {
          var active = slideIndex === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        if (dots) {
          dots.querySelectorAll('button').forEach(function (dot, dotIndex) {
            dot.classList.toggle('is-active', dotIndex === index);
            dot.setAttribute('aria-current', dotIndex === index ? 'true' : 'false');
          });
        }
      }

      if (dots) {
        dots.innerHTML = slides.map(function (_, dotIndex) {
          return '<button type="button" aria-label="Show slide ' + (dotIndex + 1) + '"></button>';
        }).join('');
        dots.querySelectorAll('button').forEach(function (dot, dotIndex) {
          dot.addEventListener('click', function () {
            setIndex(dotIndex);
          });
        });
      }

      if (prev) {
        prev.addEventListener('click', function () {
          setIndex(index - 1);
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          setIndex(index + 1);
        });
      }

      // Swipe support (touch/pen only -- mouse drag is left alone so
      // desktop still navigates via the arrows/dots exactly as before).
      // touch-action: pan-y hands vertical drags straight to the page's
      // own scrolling and only lets our pointer handlers see horizontal
      // ones, so a swipe here never fights scrolling the page.
      track.style.touchAction = 'pan-y';
      var swipePointerId = null;
      var swipeStartX = 0;
      var swipeStartY = 0;
      var swipeDeltaX = 0;
      var swipeIsHorizontal = null;
      var SWIPE_THRESHOLD = 40;

      track.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'mouse') return;
        swipePointerId = event.pointerId;
        swipeStartX = event.clientX;
        swipeStartY = event.clientY;
        swipeDeltaX = 0;
        swipeIsHorizontal = null;
      }, { passive: true });

      track.addEventListener('pointermove', function (event) {
        if (swipePointerId === null || event.pointerId !== swipePointerId) return;
        var dx = event.clientX - swipeStartX;
        var dy = event.clientY - swipeStartY;
        if (swipeIsHorizontal === null && (Math.abs(dx) > 6 || Math.abs(dy) > 6)) {
          swipeIsHorizontal = Math.abs(dx) > Math.abs(dy);
        }
        if (swipeIsHorizontal) {
          swipeDeltaX = dx;
          if (event.cancelable) event.preventDefault();
        }
      }, { passive: false });

      function endSwipe(event) {
        if (swipePointerId === null || event.pointerId !== swipePointerId) return;
        if (swipeIsHorizontal && Math.abs(swipeDeltaX) > SWIPE_THRESHOLD) {
          setIndex(index + (swipeDeltaX < 0 ? 1 : -1));
        }
        swipePointerId = null;
        swipeIsHorizontal = null;
        swipeDeltaX = 0;
      }
      track.addEventListener('pointerup', endSwipe, { passive: true });
      track.addEventListener('pointercancel', endSwipe, { passive: true });

      setIndex(0);
    });
  }

  function initXLoopMarquees(root) {
    var scope = root || document;
    scope.querySelectorAll(selectors.xLoopHolder).forEach(function (holder) {
      if (holder.dataset.totlXLoopBound === 'true') return;
      holder.dataset.totlXLoopBound = 'true';

      // The upstream reference (tearsoftheleft.webflow.io) drives this with
      // JS: it translates the strip continuously and wraps the offset
      // modulo a SINGLE repeated item's width, applying that same offset
      // to the whole row every frame. That loop point never depends on how
      // much content is duplicated - only on there being enough rendered
      // width to cover the viewport at all.
      //
      // Our old CSS `0% -> -50%` keyframe was a different (and fragile)
      // technique: it only looks seamless while the *entire* duplicated
      // strip stays at least 2x the viewport (the wrap only hides itself if
      // there's a full viewport of rendered content on both sides of the
      // shift), which broke down - a gap partway through the strip once per
      // loop - on wide viewports. Replicate the upstream, viewport-size-
      // independent technique instead.
      var baseItems = Array.prototype.slice.call(holder.children);
      if (!baseItems.length) return;

      function currentItemWidth() {
        return baseItems[0].getBoundingClientRect().width || 0;
      }

      function ensureCoverage() {
        var viewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;
        var itemWidth = currentItemWidth();
        var target = viewportWidth + itemWidth * 2;
        var guard = 0;
        while (itemWidth > 0 && holder.scrollWidth < target && guard < 400) {
          baseItems.forEach(function (item) {
            holder.appendChild(item.cloneNode(true));
          });
          guard += 1;
        }
      }

      function measurePxPerSecond() {
        // Read the CSS-authored duration for the current breakpoint (not
        // any inline override) so pace stays correct if the viewport
        // crosses a media-query boundary (mobile vs. desktop has a
        // different font size and a different base duration).
        var savedAnimation = holder.style.animation;
        holder.style.animation = '';
        var duration = parseFloat(getComputedStyle(holder).animationDuration) || 0;
        holder.style.animation = savedAnimation;
        var itemWidth = currentItemWidth();
        return duration > 0 ? (itemWidth * baseItems.length / 2) / duration : 54.5;
      }

      ensureCoverage();
      holder.style.animation = 'none';

      var pxPerSecond = measurePxPerSecond();
      var itemWidth = currentItemWidth();
      var offset = 0;
      var lastTime = null;

      function frame(now) {
        if (lastTime !== null && itemWidth > 0) {
          var dt = (now - lastTime) / 1000;
          offset = (offset - pxPerSecond * dt) % itemWidth;
        }
        lastTime = now;
        holder.style.transform = 'translate3d(' + offset.toFixed(2) + 'px,0,0)';
        window.requestAnimationFrame(frame);
      }
      window.requestAnimationFrame(frame);

      function remeasure() {
        ensureCoverage();
        pxPerSecond = measurePxPerSecond();
        itemWidth = currentItemWidth();
      }

      var resizeTimer;
      window.addEventListener('resize', function () {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(remeasure, 150);
      });

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(remeasure);
      }
    });
  }

  function updateHomeHero() {
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 1;
    var viewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;
    var isMobileViewport = viewportWidth <= 767;
    document.querySelectorAll(selectors.homeHero).forEach(function (hero) {
      var rect = hero.getBoundingClientRect();
      // Matches the ~0.16 * viewport-height fade distance measured on
      // tearsoftheleft.com for the silhouette-layer crossfade (holds for
      // both mobile and desktop there).
      var fadeDistance = viewportHeight * 0.16;
      var rawProgress = clamp(-rect.top / fadeDistance, 0, 1);
      var progress = smoothstep(0, 1, rawProgress);

      hero.style.setProperty('--totl-hero-bottle-dark-opacity', (1 - progress).toFixed(3));
      hero.style.setProperty('--totl-hero-bottle-scale', (isMobileViewport ? 1 : lerp(0.992, 1.012, progress)).toFixed(3));
    });
  }

  function updateTearScene() {
    var sticky = document.querySelector(selectors.tearSticky);
    var section = document.querySelector(selectors.tearSection);
    if (!sticky || !section) return;

    var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 1;
    var viewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;
    var isMobileViewport = viewportWidth <= 767;
    var scrollY = window.scrollY || window.pageYOffset || 0;
    var sectionRect = section.getBoundingClientRect();
    var sectionTop = scrollY + sectionRect.top;
    var sectionBottom = scrollY + sectionRect.bottom;
    var heroCta = document.querySelector(selectors.heroCta);
    var heroSection = document.querySelector(selectors.homeHero);
    var glass = document.querySelector(selectors.bourbonGlass);
    var heroCtaRect = heroCta ? heroCta.getBoundingClientRect() : null;
    var heroSectionRect = heroSection ? heroSection.getBoundingClientRect() : null;
    var glassRect = glass ? glass.getBoundingClientRect() : null;
    var stickyAnchor = viewportHeight * 0.4;
    var startScroll = sectionTop - viewportHeight * 0.5;
    var endScroll = sectionBottom - viewportHeight * 0.45;
    // top: 40vh (see the CSS) plus this offset is where the drop first
    // renders. A prior version pushed this down under the "Buy now" CTA
    // (~89-96vh) and let `growth` below lerp it back up to the 0 (40vh)
    // resting spot -- but that read as the drop visibly jumping upward
    // partway through the scroll, which per request it should never do
    // (only downward, via endY/glassEase further down). Zero here means
    // `growth` no longer moves it at all; only scale/opacity animate on
    // entry, and it's already sitting at its resting position from the start.
    var startY = 0;
    var endY = viewportHeight * 0.2;

    if (heroCtaRect) {
      // Only the scroll boundary is re-derived from the live rect (it stays
      // stable because scrollY + rect.top is scroll-invariant). startY must
      // stay a fixed constant -- assigning it from the live rect here made it
      // drift further negative every frame as the user scrolled past the CTA,
      // sending the drop rocketing off the top of the viewport instead of
      // floating in place.
      startScroll = scrollY + heroCtaRect.top + heroCtaRect.height * 0.5 - stickyAnchor;
    }

    if (heroSectionRect) {
      // Per request, the drop should appear right as soon as the user
      // starts scrolling down on both desktop and mobile, not after a long
      // scroll distance (an earlier version of this held the reveal back
      // until the hero section had scrolled almost fully out of view,
      // which read as far too slow to appear) -- pin the start near the
      // very top of the page instead of waiting on the hero/CTA position.
      startScroll = viewportHeight * 0.02;
    }

    if (glassRect) {
      endScroll = scrollY + glassRect.top + glassRect.height * 0.52 - stickyAnchor;
    }

    var sectionTravel = Math.max(1, endScroll - startScroll);
    var processProgress = clamp((scrollY - startScroll) / sectionTravel, 0, 1);
    var visible = smoothstep(0, isMobileViewport ? 0.08 : 0.12, processProgress);
    // stoneProgress/hide below used to be processProgress fractions (e.g.
    // smoothstep(0.85, 0.93, processProgress)), but processProgress's own
    // scale depends on endScroll, which is re-derived from the glass
    // element's live rect every frame -- and the glass itself animates
    // (updateBourbonReveal), so that rect drifts as the user scrolls,
    // making a fixed fraction land at different actual scroll positions
    // from one moment to the next. Switched both to absolute scroll
    // distance past sectionBottom instead, which is stable regardless.
    // Was 0.3 / 0.25 -- per request the stone should show up sooner after
    // Step 3 clears, not after this much extra scroll distance.
    var stoneRevealSpan = viewportHeight * (isMobileViewport ? 0.15 : 0.18);
    // Was sectionBottom exactly, then -0.12vh, -0.22vh, -0.34vh, -0.46vh --
    // per request it should start a little earlier again.
    var stoneRevealStart = sectionBottom - viewportHeight * 0.58;
    var stoneRevealT = clamp((scrollY - stoneRevealStart) / stoneRevealSpan, 0, 1);
    var hideSpan = viewportHeight * (isMobileViewport ? 0.18 : 0.22);
    var hideT = clamp((scrollY - (stoneRevealStart + stoneRevealSpan)) / hideSpan, 0, 1);
    var hide = smoothstep(0, 1, hideT);
    var activeOpacity = visible * (1 - hide);
    // Reference fades in gradually too (opacity measured rising from 0 to 1
    // over a real, noticeable span, not snapping in within the first ~16%).
    // Widened to match that more gradual reveal.
    var fadeToFull = smoothstep(0.05, 0.32, processProgress);
    // Floor is 0 now (was 0.15, then 0.35 originally) -- matches reference,
    // which measures literally 0 opacity for the first stretch of scroll,
    // not partially visible.
    var opacity = activeOpacity * fadeToFull;
    // Was 0.42-0.64 (desktop) / 0.46-0.72 (mobile). Per request this was
    // reading as changing too late -- pulled back earlier again, landing
    // between the very first (0.24-0.48) and the previous (0.42-0.64)
    // attempts.
    var amberProgress = smoothstep(isMobileViewport ? 0.34 : 0.3, isMobileViewport ? 0.58 : 0.5, processProgress);
    // Was smoothstep(0.66, 0.74, processProgress) -- the stone drop was
    // appearing while Step 2/3 were still on screen. Now tied to
    // stoneRevealT (see above, absolute scroll distance past sectionBottom)
    // so it can't render until Step 3 -- the section's last child -- has
    // fully scrolled past, no matter how the glass's own animation drifts
    // processProgress elsewhere.
    var stoneProgress = smoothstep(0, 1, stoneRevealT);
    var colorOpacity = activeOpacity * (1 - stoneProgress);
    var stoneOpacity = activeOpacity * stoneProgress;
    // startY is 0 now (see above), so growth no longer drives any vertical
    // motion -- only the scale-up below rides on it. Reference grows
    // continuously (measured: scale climbs steadily from 0.4 to ~0.8 across
    // most of its scroll, not a quick early snap), so widened this back out
    // from (0.02, 0.18) to read as a gradual, ongoing grow instead of an
    // instant pop to full size.
    var growth = smoothstep(0.02, 0.45, processProgress);
    // Reference's drop starts at scale(0.4) (measured directly via its
    // inline style at scroll start) -- lowered from 0.65 to match.
    // Target scale bumped from 1.02 -- per request it should get slightly
    // larger as it grows in, not just reach roughly its natural size.
    var scale = lerp(0.4, 1.2, growth);
    // glassEase/endY used to ride on processProgress (glass-anchored, but
    // via the same fragile endScroll noted above) and used a fixed endY
    // constant -- so the drop settled at some arbitrary fixed height that
    // didn't actually correspond to the glass image's real position, and by
    // the time `hide` (now anchored to sectionBottom) finished fading it
    // out, the two were out of sync -- it was disappearing well past the
    // glass, not on top of it. Re-anchored both to the glass's own live
    // position (like startScroll/heroCtaRect above) and to the same
    // sectionBottom-relative timeline hide/stoneProgress use, so the drop
    // slides onto the glass and finishes arriving right as it fades out.
    // Tied to hideT alone at first, but the glass keeps scrolling upward
    // the whole time, including during the stone reveal before hideT even
    // starts moving -- so by the time position-syncing began, the glass had
    // already drifted well away from the drop's still-40vh resting spot,
    // and glassEase didn't have enough scroll distance left to catch up
    // before opacity hit 0. Starts at stoneRevealStart instead (same start
    // as stoneRevealT) so it has the full distance to track the glass
    // smoothly.
    var landT = clamp((scrollY - stoneRevealStart) / (stoneRevealSpan + hideSpan), 0, 1);
    var glassEase = smoothstep(0, 1, landT);
    // glassRect.top is already viewport-relative (live, updates every
    // frame as the page scrolls), so no scrollY term is needed here --
    // this converts "where the glass sits on screen right now" into the
    // same offset-from-the-40vh-anchor space `y` operates in. Also
    // subtracts half the sticky's own current (already-scaled) rendered
    // height, since `top` positions its box's top edge, not its center --
    // without this it was aligning the drop's top edge to the glass's
    // center, landing visibly low/off by roughly half the drop's height.
    var stickyRect = sticky.getBoundingClientRect();
    var liveEndY = glassRect ? (glassRect.top + glassRect.height * 0.45 - stickyAnchor - stickyRect.height * 0.5) : endY;
    scale = lerp(scale, 0.72, glassEase);
    var y = lerp(startY, 0, growth);
    y = lerp(y, liveEndY, glassEase);
    // Webflow reference only animates saturate() here (grayscale -> color)
    // and keeps the drop at full brightness throughout. The old brightness
    // curve crushed down to 8-16% at the start, rendering the drop nearly
    // black against the dark background regardless of opacity -- so it
    // still looked invisible even once fully faded in. Keep brightness/
    // contrast close to neutral so saturation does the reveal work instead.
    var saturation = lerp(0, 118, amberProgress);
    var brightness = lerp(0.98, 1.08, amberProgress);
    brightness = lerp(brightness, 0.98, stoneProgress);
    var contrast = lerp(1.04, 1.06, amberProgress);
    var yValue = Math.round(y) + 'px';
    var scaleValue = scale.toFixed(3);
    var filterValue = 'saturate(' + Math.round(saturation) + '%) brightness(' + brightness.toFixed(3) + ') contrast(' + contrast.toFixed(3) + ')';
    var transformValue = 'translate3d(-50%, ' + yValue + ', 0) scale3d(' + scaleValue + ', ' + scaleValue + ', 1)';
    var colorDrop = sticky.querySelector('[data-totl-tear-color]');
    var stoneDrop = sticky.querySelector('[data-totl-tear-stone]');

    sticky.style.setProperty('--totl-tear-opacity', opacity.toFixed(3));
    sticky.style.setProperty('--totl-tear-stone-opacity', stoneOpacity.toFixed(3));
    sticky.style.setProperty('--totl-tear-color-opacity', colorOpacity.toFixed(3));
    sticky.style.setProperty('--totl-tear-scale', scaleValue);
    sticky.style.setProperty('--totl-tear-y', yValue);
    sticky.style.setProperty('--totl-tear-saturation', Math.round(saturation) + '%');
    sticky.style.setProperty('--totl-tear-brightness', brightness.toFixed(3));
    sticky.style.setProperty('--totl-tear-contrast', contrast.toFixed(3));
    sticky.style.opacity = opacity.toFixed(3);
    sticky.style.filter = filterValue;
    sticky.style.transform = transformValue;
    sticky.style.transformStyle = 'preserve-3d';
    if (colorDrop) colorDrop.style.opacity = colorOpacity.toFixed(3);
    if (stoneDrop) stoneDrop.style.opacity = stoneOpacity.toFixed(3);
  }

  function updateBourbonReveal() {
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 1;
    document.querySelectorAll(selectors.bourbonReveal).forEach(function (section) {
      var rect = section.getBoundingClientRect();
      var progress = smoothstep(0, 1, clamp((viewportHeight * 0.95 - rect.top) / (viewportHeight * 0.72), 0, 1));
      var text = section.querySelector('.tear_bourbon_text_wrapper');
      var heading = section.querySelector('.tear_bourbon_heading1');
      var subheading = section.querySelector('.bourbon_subheading');
      var glass = section.querySelector('.glass_wrapper');
      var box = section.querySelector('.bourbon_box_wrapper');
      var gradient = section.querySelector('.bourbon_gradient');

      setStyle(text, 'opacity', String(lerp(0.18, 1, progress)));
      setStyle(text, 'transform', 'translate3d(0, ' + Math.round(lerp(64, 0, progress)) + 'px, 0) scale(' + lerp(0.94, 1, progress).toFixed(3) + ')');
      setStyle(text, 'filter', 'blur(' + lerp(4, 0, progress).toFixed(2) + 'px)');

      setStyle(heading, 'letterSpacing', lerp(0.18, 0.02, progress).toFixed(3) + 'em');
      setStyle(subheading, 'transform', 'translate3d(' + Math.round(lerp(-32, 0, progress)) + 'px, 0, 0)');

      setStyle(glass, 'opacity', String(lerp(0.32, 1, progress)));
      setStyle(glass, 'transform', 'translate3d(0, ' + Math.round(lerp(48, 0, progress)) + 'px, 0) scale(' + lerp(0.95, 1, progress).toFixed(3) + ')');

      setStyle(box, 'opacity', String(lerp(0.25, 1, progress)));
      setStyle(box, 'transform', 'translate3d(' + Math.round(lerp(56, 0, progress)) + 'px, 0, 0) scale(' + lerp(1.04, 1, progress).toFixed(3) + ')');

      setStyle(gradient, 'opacity', String(lerp(0.16, 1, progress)));
    });
  }

  function updateBourbonStoryImages() {
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 1;
    document.querySelectorAll(selectors.bourbonStoryImage).forEach(function (imageWrap) {
      var rect = imageWrap.getBoundingClientRect();
      var progress = clamp((viewportHeight - rect.top) / (viewportHeight + rect.height), 0, 1);
      // Matches tearsoftheleft.webflow.io/bourbon: each stage image drifts
      // in from an offset, rotated position as it enters the viewport and
      // settles rotated the other way with a small residual offset once it
      // has scrolled past (measured via its rendered transform matrix at
      // several real scroll positions: rotate -4.5deg -> +2deg, x -16px ->
      // 0px, y -14px -> +16px). Previously this only rotated in place.
      var rotate = lerp(-4.5, 2, progress);
      var x = lerp(-16, 0, progress);
      var y = lerp(-14, 16, progress);
      imageWrap.style.setProperty('--totl-story-rotate', rotate.toFixed(3) + 'deg');
      imageWrap.style.setProperty('--totl-story-x', x.toFixed(2) + 'px');
      imageWrap.style.setProperty('--totl-story-y', y.toFixed(2) + 'px');
    });
  }

  function updateCollectorStoryParallax() {
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 1;
    var viewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;
    // Matches the reference site: the story background images drift downward
    // (translateY increases) as the section scrolls up through the viewport,
    // giving them a slower, lagging parallax feel relative to the text. The
    // mobile layout stacks these full-width in normal flow instead, so skip
    // the transform there to avoid fighting that layout.
    if (viewportWidth <= 767) {
      document.querySelectorAll(selectors.collectorStory).forEach(function (section) {
        section.querySelectorAll('.tear_collector_story_image_wrapper').forEach(function (wrap) {
          wrap.style.transform = '';
        });
      });
      return;
    }
    document.querySelectorAll(selectors.collectorStory).forEach(function (section) {
      var rect = section.getBoundingClientRect();
      var progress = clamp((viewportHeight - rect.top) / (viewportHeight + rect.height), 0, 1);
      // Reference site (tearsoftheleft.webflow.io/x-legends) measured total
      // drift is only ~83px (settled endpoints ~131px -> ~213px), not the
      // 940px this used to span -- that read as flying past too fast/far.
      // Easing progress through smoothstep also means the motion settles
      // into place near either end instead of tracking scroll at a
      // constant linear rate, giving it the slower "ease out" feel.
      var eased = smoothstep(0, 1, progress);
      var yValue = Math.round(lerp(-35, 48, eased)) + 'px';
      section.querySelectorAll('.tear_collector_story_image_wrapper').forEach(function (wrap) {
        wrap.style.transform = 'translate3d(0, ' + yValue + ', 0)';
      });
    });
  }

  function updateBookScene() {
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 1;
    document.querySelectorAll(selectors.bookScene).forEach(function (scene) {
      if (scene.closest('.totl-book-page__flip')) {
        return;
      }
      var section = scene.closest('.book-section') || scene;
      var rect = section.getBoundingClientRect();
      var progress = smoothstep(0, 1, clamp((viewportHeight * 0.9 - rect.top) / (viewportHeight * 0.68), 0, 1));
      var offsets = {
        'is-1': [96, -108],
        'is-2': [-78, 116],
        'is-3': [142, 18],
        'is-4': [-154, 12],
        'is-5': [88, 116],
        'is-6': [-104, -118]
      };

      scene.querySelectorAll('.book_character_wrapper').forEach(function (character) {
        var key = '';
        Object.keys(offsets).some(function (className) {
          if (character.classList.contains(className)) {
            key = className;
            return true;
          }
          return false;
        });
        var offset = offsets[key] || [0, 0];
        var x = Math.round(lerp(offset[0], 0, progress));
        var y = Math.round(lerp(offset[1], 0, progress));
        setStyle(character, 'opacity', lerp(0.08, 1, progress).toFixed(3));
        setStyle(character, 'transform', 'translate3d(' + x + 'px, ' + y + 'px, 0) scale(' + lerp(0.82, 1, progress).toFixed(3) + ')');
      });
    });
  }

  function updateBookFlip() {
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 1;
    var isMobile = (window.innerWidth || document.documentElement.clientWidth || 0) <= 749;
    var characterOffsets = {
      'is-1': [96, -108],
      'is-2': [-78, 116],
      'is-3': [142, 18],
      'is-4': [-154, 12],
      'is-5': [88, 116],
      'is-6': [-104, -118]
    };
    document.querySelectorAll(selectors.bookFlipStage).forEach(function (stage) {
      var rect = stage.getBoundingClientRect();
      // travel has to match how far the sticky child can actually travel
      // before position:sticky releases it (stage height minus the
      // sticky's OWN height) — not the viewport height. Those used to be
      // the same number back when the sticky was forced to a full
      // 100svh, but now that it's sized to its own (much shorter)
      // content, using viewportHeight here would make this progress
      // value hit 1 long before the sticky actually un-pins, so the flip
      // would finish almost instantly and then just sit there fully open
      // for the rest of the pinned scroll.
      var stickyEl = stage.querySelector('.totl-book-page__flip-sticky');
      var stickyHeight = stickyEl ? stickyEl.getBoundingClientRect().height : viewportHeight;
      var travel = Math.max(1, rect.height - stickyHeight);
      var raw = clamp(-rect.top / travel, 0, 1);
      var progress = smoothstep(0, 1, raw);
      var characterProgress = smoothstep(0.5, 0.92, progress);

      // The cover + left inner page share one continuous flip, exactly
      // like tearsoftheleft.com/thebookoftears at every viewport size:
      // both stay fully opaque through the visible part of the swing
      // (real paper doesn't turn see-through) — rotateY + the shared 3D
      // perspective alone make one appear to swing away and the other
      // swing into view. Two sibling planes rotating opposite directions
      // inside the same preserve-3d box don't reliably depth-sort by
      // z-index though (the browser depth-sorts by actual 3D position
      // instead), so at rest — both at their resting rotation — they can
      // visibly overlap/bleed into each other. revealProgress snaps each
      // one's opacity only right at the very end of ITS OWN swing
      // (already edge-on/near-flat and thin from foreshortening by then,
      // so the snap isn't perceptible), which keeps exactly one of them
      // visible at rest without reintroducing the full-swing "ghosting"
      // fade. Mobile's total scroll-jack distance is much shorter than
      // desktop's (tuned to match tearsoftheleft.com/thebookoftears'
      // own short mobile section instead of forcing a long scroll), so
      // the flip window is stretched across nearly the whole pinned
      // travel — otherwise the same fraction of a shorter travel
      // finishes in far fewer scrolled pixels and reads as a rushed
      // snap instead of a slow, deliberate open.
      var flipProgress = isMobile ? smoothstep(0.06, 0.95, progress) : smoothstep(0.18, 0.6, progress);
      var revealProgress = smoothstep(0.7, 1, flipProgress);

      stage.style.setProperty('--totl-book-cover-opacity', (1 - revealProgress).toFixed(3));
      stage.style.setProperty('--totl-book-cover-x', lerp(50, 0, flipProgress).toFixed(2) + '%');
      stage.style.setProperty('--totl-book-cover-rotate', lerp(0, -90, flipProgress).toFixed(2) + 'deg');
      stage.style.setProperty('--totl-book-left-page-opacity', revealProgress.toFixed(3));
      stage.style.setProperty('--totl-book-left-page-x', lerp(10, 0, flipProgress).toFixed(2) + '%');
      stage.style.setProperty('--totl-book-left-rotate', lerp(90, 0, flipProgress).toFixed(2) + 'deg');
      stage.style.setProperty('--totl-book-right-page-x', lerp(-50, 0, flipProgress).toFixed(2) + '%');
      stage.style.setProperty('--totl-book-character-opacity', characterProgress.toFixed(3));

      // Match tearsoftheleft.com/thebookoftears: the character cutouts
      // aren't just fading in at their resting spot around the book, they
      // fly in from further past the book's edge (same technique as
      // updateBookScene's offsets above, reused here since it's the same
      // set of characters clustered the same way around the same book).
      stage.querySelectorAll('.book_character_wrapper').forEach(function (character) {
        var key = '';
        Object.keys(characterOffsets).some(function (className) {
          if (character.classList.contains(className)) {
            key = className;
            return true;
          }
          return false;
        });
        var offset = characterOffsets[key] || [0, 0];
        var x = Math.round(lerp(offset[0], 0, characterProgress));
        var y = Math.round(lerp(offset[1], 0, characterProgress));
        setStyle(character, 'transform', 'translate3d(' + x + 'px, ' + y + 'px, 0) scale(' + lerp(0.82, 1, characterProgress).toFixed(3) + ')');
      });
    });
  }

  function updateGameDice() {
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 1;
    var scrollY = window.scrollY || window.pageYOffset || 0;
    document.querySelectorAll(selectors.gameDice).forEach(function (dice) {
      var section = dice.closest('.totl-game-welcome') || dice;
      var board = section.querySelector('.totl-game-welcome__board');
      var rect = section.getBoundingClientRect();
      var boardRect = board ? board.getBoundingClientRect() : null;
      var sectionTop = scrollY + rect.top;
      var boardTop = boardRect ? scrollY + boardRect.top : sectionTop + rect.height * 0.52;
      var startScroll = sectionTop - viewportHeight * 0.28;
      var endScroll = boardTop - viewportHeight * 0.2;
      var progress = smoothstep(0, 1, clamp((scrollY - startScroll) / Math.max(1, endScroll - startScroll), 0, 1));
      var curve = Math.sin(progress * Math.PI);
      var boardWidth = boardRect ? boardRect.width : Math.min(window.innerWidth || 1440, 1080);
      var startX = -Math.min(320, boardWidth * 0.34);
      var endX = -Math.min(360, boardWidth * 0.31);
      var startY = Math.max(170, viewportHeight * 0.28);
      // Text placed above the board (is-copy-top): start the dice below it
      // so it doesn't fly over the copy.
      var copy = section.querySelector('.totl-game-welcome__copy');
      if (copy && boardRect) {
        var copyRect = copy.getBoundingClientRect();
        if (copyRect.top < boardRect.top) startY = Math.max(startY, copyRect.bottom - rect.top);
      }
      var endY = boardRect ? boardRect.top - rect.top + boardRect.height * 0.08 : rect.height * 0.54;
      var x = lerp(startX, endX, progress) - curve * Math.min(120, boardWidth * 0.11);
      var y = lerp(startY, endY, progress) - curve * Math.min(120, viewportHeight * 0.16);
      var rotate = lerp(-18, 13, progress) + curve * 16;
      var scale = lerp(0.74, 0.96, progress);
      var opacity = lerp(0.82, 1, smoothstep(0, 0.18, progress));

      dice.style.setProperty('--totl-game-dice-x', Math.round(x) + 'px');
      dice.style.setProperty('--totl-game-dice-y', Math.round(y) + 'px');
      dice.style.setProperty('--totl-game-dice-rotate', rotate.toFixed(2) + 'deg');
      dice.style.setProperty('--totl-game-dice-scale', scale.toFixed(3));
      dice.style.setProperty('--totl-game-dice-opacity', opacity.toFixed(3));
    });
  }

  function updateLegendGallery() {
    // Match tearsoftheleft.com/x-legends/xltc-03's 3-photo gallery.
    // Confirmed by sampling computed style across real (not synthetic)
    // scroll positions: the zoom is NOT a one-time reveal that settles
    // once visible — it's continuous and reversible, tied directly to
    // scroll position, and keeps growing well past the point the image
    // is fully in view (measured scale climbing from 1.0 to 1.15+ as
    // scrollY increased, and dropping back down when scrolling back up).
    // Opacity/position still fade in quickly on entry (short range);
    // the zoom itself plays out over a longer scroll distance with an
    // ease curve (matching the reference's accelerate-then-settle feel)
    // and settles at a bolder scale(1.3) — the reference itself caps at
    // exactly scale(1.2) (confirmed: it holds at 1.19998 no matter how
    // far past it you keep scrolling), but that read as too subtle here,
    // so this pushes past literal parity for a clearly noticeable zoom.
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 1;
    document.querySelectorAll(selectors.legendGallery).forEach(function (gallery) {
      var items = gallery.querySelectorAll('.totl-legend-detail__gallery-item');
      items.forEach(function (item, index) {
        var image = item.querySelector('.totl-legend-detail__gallery-image');
        if (!image) return;
        var rect = item.getBoundingClientRect();
        var stagger = index * 0.08;
        var entryProgress = smoothstep(0, 1, clamp((viewportHeight * 0.92 - rect.top) / (viewportHeight * 0.5) - stagger, 0, 1));
        var zoomProgress = smoothstep(0, 1, clamp((viewportHeight * 0.92 - rect.top) / (viewportHeight * 1.8) - stagger, 0, 1));
        setStyle(image, 'opacity', String(lerp(0.15, 1, entryProgress)));
        setStyle(image, 'transform', 'translate3d(0, ' + Math.round(lerp(48, 0, entryProgress)) + 'px, 0) scale(' + lerp(1, 1.3, zoomProgress).toFixed(3) + ')');
      });
    });
  }

  function updateScrollScenes() {
    scrollSceneRaf = null;
    updateHomeHero();
    updateTearScene();
    updateBourbonReveal();
    updateBourbonStoryImages();
    updateCollectorStoryParallax();
    updateBookFlip();
    updateBookScene();
    updateGameDice();
    updateLegendGallery();
  }

  function requestScrollSceneUpdate() {
    if (scrollSceneRaf) return;
    scrollSceneRaf = window.requestAnimationFrame(updateScrollScenes);
  }

  function initScrollScenes() {
    if (!scrollScenesBound) {
      scrollScenesBound = true;
      window.addEventListener('scroll', requestScrollSceneUpdate, { passive: true });
      window.addEventListener('resize', requestScrollSceneUpdate);
    }
    requestScrollSceneUpdate();
  }

  function reinitWebflow() {
    if (!window.Webflow) return;
    try {
      window.Webflow.destroy();
      window.Webflow.ready();
      if (window.Webflow.require) {
        var ix2 = window.Webflow.require('ix2');
        if (ix2 && ix2.init) ix2.init();
      }
    } catch (error) {
      window.console && window.console.warn && window.console.warn('Webflow reinit skipped', error);
    }
    requestScrollSceneUpdate();
  }

  function init(root) {
    initAgeGate(root);
    initRetailPasswordGate(root);
    initForceDownloadLinks(root);
    initProductForms(root);
    initNav(root);
    initNavDropdowns(root);
    initCartDrawer(root);
    initSmoothAnchors(root);
    initShowAllReveal(root);
    initGameSliders(root);
    initXLoopMarquees(root);
    initScrollScenes();
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (window.Shopify && window.Shopify.designMode) document.documentElement.classList.add('totl-theme-editor');
    init(document);
    window.setTimeout(reinitWebflow, 250);
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
    window.setTimeout(reinitWebflow, 100);
  });
})();
